import { OptimizerFrequency, OptimizerStrategy } from 'PortfolioOptimizerApp/enums/portfolio-optimizer.enum';
export const PORTFOLIO_OPTIMIZER_APP_STATE_SLICE_KEY = 'portfolioOptimizer';
export const PORTFOLIO_OPTIMIZER_DEFAULT_STATE = {
    baselinePortfolioId: null,
    optimizerId: null,
    optimizedWeightings: null,
    frequency: OptimizerFrequency.Monthly,
    startDate: '',
    endDate: '',
    strategy: OptimizerStrategy.MinimizeStandardDeviation,
    targetValue: null,
    weightBounds: {},
    initialTab: null,
    autoCalculate: false,
    selectedPortfolio: null,
    cashOptimized: null,
    comparisonPortfolios: [],
};
export const SAVED_PORTFOLIO_OPTIMIZER_MINIMUM_STATE_KEYS = [
    'baselinePortfolioId',
    'startDate',
    'endDate',
    'frequency',
    'strategy',
    'targetValue',
    'weightBounds',
];
export const SAVED_PORTFOLIO_OPTIMIZER_STATE_KEYS = [
    ...SAVED_PORTFOLIO_OPTIMIZER_MINIMUM_STATE_KEYS,
    'initialTab',
    'autoCalculate',
    'cashOptimized',
];
export const PORTFOLIO_OPTIMIZER_STATE_KEYS = ['optimizerId', ...SAVED_PORTFOLIO_OPTIMIZER_STATE_KEYS];
export const PORTFOLIO_OPTIMIZER_FREQUENCY_DROPDOWN_OPTIONS_LIST = [
    {
        type: 'option',
        label: 'Daily',
        value: OptimizerFrequency.Daily,
    },
    {
        type: 'option',
        label: 'Monthly',
        value: OptimizerFrequency.Monthly,
    },
    {
        type: 'option',
        label: 'Quarterly',
        value: OptimizerFrequency.Quarterly,
    },
    {
        type: 'option',
        label: 'Annually',
        value: OptimizerFrequency.Annually,
    },
];
export const PORTFOLIO_OPTIMIZER_STRATEGY_DROPDOWN_OPTIONS_LIST = [
    {
        type: 'option',
        label: 'Maximize Sharpe Ratio',
        value: OptimizerStrategy.MaximizeSharpeRatio,
    },
    {
        type: 'option',
        label: 'Target Return',
        value: OptimizerStrategy.TargetReturn,
    },
    {
        type: 'option',
        label: 'Target Standard Deviation',
        value: OptimizerStrategy.TargetStandardDeviation,
    },
    {
        type: 'option',
        label: 'Minimize Standard Deviation',
        value: OptimizerStrategy.MinimizeStandardDeviation,
    },
];
